const initialState = {
  cuposVigentes: [],
  cuposDisponibles: [],
  cuposCacheNominados: [],
  requestingConsultaCuposNominadosVigentes: false,
  cuposNominadosVigentes: [],
  cuposVigentesFiltrados: [],
  isRequestingTiposCupos: false,
  tiposCupos: [],
  showMsgToast: false,
  currentCupo: null,
  currentCupoNominando: null,
  showNominacion: false,
  codigoDeCupo: null,
  cerealesAdelanto: [],
  limiteCupoDesde: null,
  limiteCupoHasta: null,
  exportador: null,
  correosSeleccionados: null,
  openAddCorreo: false,
  openEditCorreo: false,
  isValidEmail: false,
  contacto: null,
  listaDeContactos: null,
  cuposSeleccionados: null,
  notificarPorCorreo: true,
  enviarATodos: true,
  correoCorredor: null,
  correoCargador: null,
  datosDeCupo: null,
  cantidadActual: 0,
  cantidadAUtilizar: 0,
  cpaPorCodigo: null,
  aNotificarCargador: [],
  aNotificarCorredor: [],
  showNotificacion: false,
  isRequestingCupos: false,
  codigosDeCupo: [],
  totalizadorCupos: null,
  cumplimientoCupo: 100
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'REQUESTED_TIPOS_CUPOS':
      return {
        ...state,
        isRequestingTiposCupos: false,
        tiposCupos: action.tiposCupos
      }
    case 'CHOSEN_TIPO_CUPO':
      return {
        ...state,
        tipoCupo: action.tipoCupo
      }
    case 'SAVE_CUPOS_VIGENTES':
      return {
        ...state,
        cuposVigentes: action.data
      }
    case 'UPDATE_MUITABLE_CUPOS_DISPONIBLES':
      return {
        ...state,
        cuposDisponibles: action.data
      }
    case 'RESET_MUITABLE_CUPOS_DISPONIBLES':
      return {
        ...state,
        cuposDisponibles: []
      }
    case 'UPDATE_MUITABLE_CUPOS_CACHE':
      return {
        ...state,
        cuposCacheNominados: action.data
      }
    case 'RESET_MUITABLE_CUPOS_CACHE':
      return {
        ...state,
        cuposCacheNominados: []
      }
    case 'SHOW_TOAST':
      return {
        ...state,
        showMsgToast: true,
        toastMessage: action.toastMessage
      }
    case 'HIDE_TOAST':
      return {
        ...state,
        showMsgToast: false
      }
    case 'UPDATE_CUPO_NOMINANDO':
      return {
        ...state,
        cupoNominacion: action.cupo
      }
    case 'OPEN_RENOMINACION':
      return {
        ...state,
        showRenominacion: true,
        cupoRenominacion: action.cupo
      }
    case 'CLOSE_NOMINACION':
      return {
        ...state,
        showNominacion: false
      }
    case 'CLOSE_RENOMINACION':
      return {
        ...state,
        showRenominacion: false
      }
    case 'SET_CURRENT_CUPO':
      return {
        ...state,
        currentCupo: action.cupo
      }
    case 'SET_CURRENT_CUPO_RENOMINANDO':
      return {
        ...state,
        currentCupoRenominando: action.cupo
      }
    case 'RECEIVE_CODIGO_DE_CUPO':
      return {
        ...state,
        codigoDeCupo: action.data
      }
    case 'RECEIVE_CPA_POR_CODIGO':
      return {
        ...state,
        cpaPorCodigo: action.cpa
      }
    case 'SET_CODIGO_DE_CUPO':
      return {
        ...state,
        codigoDeCupo: null
      }
    case 'RECEIVE_PARAMETROS_ADELANTO_CUPOS':
      return {
        ...state,
        cerealesAdelanto: action.cerealesAdelanto && action.cerealesAdelanto['valor'],
        limiteCupoDesde: action.limiteCupoDesde && action.limiteCupoDesde['valor'],
        limiteCupoHasta: action.limiteCupoHasta && action.limiteCupoHasta['valor']
      }
    case 'DELETE_ADELANTO_PROGRAMADO':
      return {
        ...state,
        cerealesAdelanto: [],
        limiteCupoDesde: null,
        limiteCupoHasta: null
      }
    case 'RECEIVE_MOSTRAR_DIALOG_ADD_CORREO':
      return {
        ...state,
        openAddCorreo: action.estado
      }
    case 'RECEIVE_MOSTRAR_DIALOG_EDIT_CORREO':
      return {
        ...state,
        openEditCorreo: action.estado
      }
    case 'ACTUALIZAR_EXPORTADOR':
      return {
        ...state,
        exportador: action.exportador
      }
    case 'SET_CORREOS_SELECCIONADOS':
      return {
        ...state,
        correosSeleccionados: action.data
      }
    case 'CORREO_VALIDO':
      return {
        ...state,
        isValidEmail: action.estado
      }
    case 'RECEIVE_CONSULTA_CONTACTO':
      return {
        ...state,
        contacto: action.contacto
      }
    case 'UPDATE_LISTA_CONTACTOS':
      return {
        ...state,
        listaDeContactos: action.contactos
      }
    case 'RESET_LISTA_CONTACTOS':
      return {
        ...state,
        listaDeContactos: null
      }
    case 'UPDATE_LISTA_CUPOS_SELECCIONADOS':
      return {
        ...state,
        cuposSeleccionados: action.cupo
      }
    case 'RESET_LISTA_CUPOS_SELECCIONADOS':
      return {
        ...state,
        cuposSeleccionados: null
      }
    case 'UPDATE_NOTIFICAR_POR_CORREO':
      return {
        ...state,
        notificarPorCorreo: action.estado
      }
    case 'UPDATE_ENVIAR_A_TODOS':
      return {
        ...state,
        enviarATodos: action.estado
      }
    case 'REQUEST_CORREO_CORREDOR':
      return {
        ...state,
        correoCorredor: action.data
      }
    case 'REQUEST_CORREO_CARGADOR':
      return {
        ...state,
        correoCargador: action.data
      }
    case 'RESET_CORREO_CORREDOR':
      return {
        ...state,
        correoCorredor: null
      }
    case 'RESET_CORREO_CARGADOR':
      return {
        ...state,
        correoCargador: null
      }
    case 'RECEIVE_PRECARGA_NOMINACION':
      return {
        ...state,
        datosDeCupo: action.datosDeCupo
      }
    case 'RESET_PRECARGA_NOMINACION':
      return {
        ...state,
        datosDeCupo: null
      }
    case 'ACTUALIZAR_PRECARGA_NOMINACION':
      return {
        ...state,
        cantidadActual: action.cantidadActual
      }
    case 'RESET_CANTIDAD_ACTUAL':
      return {
        ...state,
        cantidadActual: 0
      }
    case 'ACTUALIZAR_CUPOS_VIGENTES_FILTRADOS':
      return {
        ...state,
        cuposVigentesFiltrados: action.cuposVigentesFiltrados
      }
    case 'RESET_CUPOS_VIGENTES_FILTRADOS':
      return {
        ...state,
        cuposVigentesFiltrados: []
      }
    case 'ACTUALIZAR_CUPOS_A_NOTIFICAR_CARGADOR':
      return {
        ...state,
        aNotificarCargador: action.aNotificarCargador
      }
    case 'RESET_CUPOS_A_NOTIFICAR_CARGADOR':
      return {
        ...state,
        aNotificarCargador: []
      }
    case 'ACTUALIZAR_CUPOS_A_NOTIFICAR_CORREDOR':
      return {
        ...state,
        aNotificarCorredor: action.aNotificarCorredor
      }
    case 'RESET_CUPOS_A_NOTIFICAR_CORREDOR':
      return {
        ...state,
        aNotificarCorredor: []
      }
    case 'OPEN_NOTIFICACION':
      return {
        ...state,
        showNotificacion: true
      }
    case 'CLOSE_NOTIFICACION':
      return {
        ...state,
        showNotificacion: false
      }
    case 'UPDATE_IS_REQUESTING_CUPOS':
      return {
        ...state,
        isRequestingCupos: action.isRequestingCupos
      }
    case 'OBTENER_CODIGOS_DE_CUPO':
      return {
        ...state,
        codigosDeCupo: action.data
      }
    case 'RESET_CODIGOS_DE_CUPO':
      return {
        ...state,
        codigosDeCupo: []
      }
    case 'RECEIVE_TOTAL_CUPOS':
      return {
        ...state,
        totalizadorCupos: action.data
      }
    case 'RECEIVE_PROMEDIO_CUMPLIMIENTO':
      return {
        ...state,
        cumplimientoCupo: action.cumplimiento
      }
    default:
      return state
  }
}
